import React, { useState } from 'react';
import { Typography, Tabs, Spacer, Row as GridRow, Col } from 'design-system';
import { TAB_FIGMA_WITH_ICONS, TAB_FIGMA_TEXT_ONLY } from './tabsShowcaseData';

const Separator = ({ className = '' }) => (
  <div className={['separator', className].filter(Boolean).join(' ')} />
);

export default function TabsShowcase() {
  const [figmaTabUnderlineIcons, setFigmaTabUnderlineIcons] = useState('me');
  const [figmaTabUnderlineText, setFigmaTabUnderlineText] = useState('me');
  const [figmaTabPill, setFigmaTabPill] = useState('unassigned');
  const [figmaTabSegmented, setFigmaTabSegmented] = useState('me');

  return (
    <>
        {/* Tabs */}
        <GridRow>
          <Col xs={12}>
            <div className="design-system-section">
              <Typography variant="h1" className="section-title mb-4">
                Tabs
              </Typography>
              <Separator className="mb-5" />
              <Tabs
                items={TAB_FIGMA_WITH_ICONS}
                value={figmaTabUnderlineIcons}
                onChange={setFigmaTabUnderlineIcons}
                variant="underline"
              />
              <Spacer size={4} />
              <Tabs
                items={TAB_FIGMA_TEXT_ONLY}
                value={figmaTabUnderlineText}
                onChange={setFigmaTabUnderlineText}
                variant="underline"
              />
              <Spacer size={4} />
              <Tabs items={TAB_FIGMA_WITH_ICONS} value={figmaTabPill} onChange={setFigmaTabPill} variant="pill" />
              <Spacer size={4} />
              <Tabs
                items={TAB_FIGMA_WITH_ICONS}
                value={figmaTabSegmented}
                onChange={setFigmaTabSegmented}
                variant="segmented"
              />
            </div>
          </Col>
        </GridRow>
    </>
  );
}